import { ProjConstants } from 'src/app/utils/proj.constant';

export const HeatwaveMapConstants = {
  CommonLayers: [
    // {
    //   layerNameType: 'STATE',
    //   serviceType: 'VectorLayer',
    //   view: 'Both',
    //   type: 'Time',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   dataurl: 'heatWatches/getHeatWatchesData',
    //   hval: 'hwv',
    //   hcat: 'hwc'
    // },
    {
      layerNameType: 'STATE',
      serviceType: 'WmsLayer',
      view: 'Both',
      type: 'Base',
      env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      pane: 'popup',
      styles: 'INDIA_STATE_NAMES',
      minZoom: 5,
    },
    // {
    //     layerNameType : 'DISTRICT',
    //     serviceType : 'WmsLayer',
    //     view : 'Both',
    //     type : 'Base',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     pane : 'village',
    //     styles:'INDIA_DISTRICT_NAMES',
    //     minZoom:8,
    //     maxZoom:9
    //   },
      {
        layerNameType : 'DISTRICT',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Time',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        dataurl : 'heatWatches/getHeatWatchesData' ,
        hval :"hwv",
        hcat : "hwc",
        pane : 'popup'
      }
  ],
  Legend: {
    colorValues: [
      {
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.normal,
        color: '#000000',
        text: 'Normal'
      },
      {
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        color: '#000000',
        text: 'Heatwave'
      },
      {
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        color: '#FFFFFF',
        text: 'Severe Heatwave'
      }
    ],
  },
  legendData: {
    levels: [
      {
        color: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        name: 'Severe Heatwave'
      },
      {
        color: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        name: 'Heatwave'
      },
      {
        color: ProjConstants.HEAT_WATCHES_LEGEND.normal,
        name: 'Normal'
      }
    ]
  }
};
